const capcourseActions = {
  GET_ALL_CAPCOURSE: "GET_ALL_CAPCOURSE",
  SET_ALL_CAPCOURSE: "SET_ALL_CAPCOURSE",

  GET_CAP_CANDIDATEDETAILS: "GET_CAP_CANDIDATEDETAILS",
  SET_CAP_CANDIDATEDETAILS: "SET_CAP_CANDIDATEDETAILS",

  GET_CAP_CANDIDATEADDRESSDETAILS: "GET_CAP_CANDIDATEADDRESSDETAILS",
  SET_CAP_CANDIDATEADDRESSDETAILS: "SET_CAP_CANDIDATEADDRESSDETAILS",

  GET_CAP_CANDIDATEACADAMICDETAILS: "GET_CAP_CANDIDATEACADAMICDETAILS",
  SET_CAP_CANDIDATEACADAMICDETAILS: "SET_CAP_CANDIDATEACADAMICDETAILS",

  GET_CAP_CANDIDATERESERVATIONDETAILS: "GET_CAP_CANDIDATERESERVATIONDETAILS",
  SET_CAP_CANDIDATERESERVATIONDETAILS: "SET_CAP_CANDIDATERESERVATIONDETAILS",

  GET_CAP_CANDIDATEUPLOADDETAILS: "GET_CAP_CANDIDATEUPLOADDETAILS",
  SET_CAP_CANDIDATEUPLOADDETAILS: "SET_CAP_CANDIDATEUPLOADDETAILS",

  GET_SCOREDETAILS: "GET_SCOREDETAILS",
  SET_SCOREDETAILS: "SET_SCOREDETAILS",

  SET_CAP_CANDIDATURE: "SET_CAP_CANDIDATURE",
  GET_CAP_CANDIDATURE: "GET_CAP_CANDIDATURE",

    GET_SCOREDETAILS:'GET_SCOREDETAILS',
    SET_SCOREDETAILS:'SET_SCOREDETAILS',


    GET_CAP_CANDIDATE_DOCUMENTS:'GET_CAP_CANDIDATE_DOCUMENTS',
    SET_CAP_CANDIDATE_DOCUMENTS:'SE_CAP_CANDIDATE_DOCUMENTS',

    CAP_UPLOADS_DOCUMENTS_CREATION : 'CAP_UPLOADS_DOCUMENTS_CREATION',
    CAP_UPLOADS_DOCUMENTS_REMOVE : 'CAP_UPLOADS_DOCUMENTS_REMOVE',

    

    SET_CAP_CATEGORY: "SET_CAP_CATEGORY",
    GET_CAP_CATEGORY: "GET_CAP_CATEGORY",

  INSERT_CAP_CANDIDATURE:"INSERT_CAP_CANDIDATURE",

  UPDATE_CAP_CANDIDATE_PERSONAL:"UPDATE_CAP_CANDIDATE_PERSONAL",
  UPDATE_CAP_CANDIDATE_ADDRESS:"UPDATE_CAP_CANDIDATE_ADDRESS",
  UPDATE_CAP_CANDIDATE_RESERVATION:"UPDATE_CAP_CANDIDATE_RESERVATION",
  UPDATE_CAP_CANDIDATE_ACADEMIC:"UPDATE_CAP_CANDIDATE_ACADEMIC",
  UPDATE_CAP_CANDIDATE_UPLOADS:"UPDATE_CAP_CANDIDATE_UPLOADS",

  GET_CAP_MASTER_FIELDS : 'GET_CAP_MASTER_FIELDS',
  
  GET_CANDIDATE_CAP_REG_DETAILS : 'GET_CANDIDATE_CAP_REG_DETAILS',
  SET_CANDIDATE_CAP_REG_DETAILS : 'SET_CANDIDATE_CAP_REG_DETAILS',

  GET_CAPCOURSE_DISTRICTS_BY_CAPCOURSEID : 'GET_CAPCOURSE_DISTRICTS_BY_CAPCOURSEID',
  SET_CAPCOURSE_DISTRICTS : 'SET_CAPCOURSE_DISTRICTS',

  GET_CAPCOURSE_VERIFICATION_CENTER : 'GET_CAPCOURSE_VERIFICATION_CENTER',
  SET_CAPCOURSE_VERIFICATION_CENTER : 'SET_CAPCOURSE_VERIFICATION_CENTER',

  GET_DATE_BY_VCENTER : 'GET_DATE_BY_VCENTER',
  SET_DATE_BY_VCENTER : 'SET_DATE_BY_VCENTER',

  GET_SLOT_VERIFYERS : 'GET_SLOT_VERIFYERS',
  SET_SLOT_VERIFYERS : 'SET_SLOT_VERIFYERS',

  GET_SLOTS_DETAILS:'GET_SLOTS_DETAILS',
  SET_SLOTS_DETAILS:'SET_SLOTS_DETAILS',

  UPDATE_SLOTS_DETAILS:'UPDATE_SLOTS_DETAILS',

  GET_BOOKED_SLOT_DETAILS:'GET_BOOKED_SLOT_DETAILS',
  SET_BOOKED_SLOT_DETAILS:'SET_BOOKED_SLOT_DETAILS',


    UPDATE_CAP_TABSTATUS:"UPDATE_CAP_TABSTATUS",

    GET_CAP_COURSE_AMOUNT:"GET_CAP_COURSE_AMOUNT",
    SET_CAP_COURSE_AMOUNT:"SET_CAP_COURSE_AMOUNT",

    FREE_CAP_COURSE_REG:"FREE_CAP_COURSE_REG",




};

export default capcourseActions;
